// Konto zalogowane w B2C, ale spoza domen Scientii, przy włączonej blokadzie w API (Access:Mode=Enforce)
import { useMsal } from "@azure/msal-react";
import { ALLOWED_DOMAINS_TEXT, AuthLayout } from "./AuthLayout";

export const NoAccess = ({ email }: { email: string | null }) => {
  const { instance } = useMsal();
  return (
    <AuthLayout>
      <h2 className="text-[22px] font-light tracking-[-0.02em] text-[var(--sc-text)] m-0">Brak dostępu</h2>
      <p className="text-[13px] text-[var(--sc-muted)] mt-2 leading-relaxed">
        Konto <strong className="font-medium text-[var(--sc-text)] break-all">{email ?? "bez adresu e-mail"}</strong> nie ma
        dostępu do Scientia Reports.
      </p>
      <p className="text-[13px] text-[var(--sc-muted)] mt-2 mb-6 leading-relaxed">
        Zaloguj się kontem służbowym Scientia ({ALLOWED_DOMAINS_TEXT}).
      </p>
      <button
        onClick={() => instance.logout()}
        className="flex w-full items-center justify-center rounded-[var(--sc-radius-md)] bg-[var(--sc-amber)] px-4 py-2.5 text-[14px] font-medium text-[#0F0F0F] border-none cursor-pointer transition-colors hover:bg-[#e09620]"
      >
        Wyloguj się i zaloguj innym kontem
      </button>
    </AuthLayout>
  );
};
